import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { resolveResponsiveProp } from '../../internal/responsive-props';
import { Box } from '../Box/Box';
import { ColumnsContext } from './Columns';
import styles from './Column.module.less';

/**
 * A single column to be used with `Columns`.
 */
export var Column = function Column(_ref) {
  var children = _ref.children,
      columnStart = _ref.columnStart,
      width = _ref.width;

  var _React$useContext = React.useContext(ColumnsContext),
      collapse = _React$useContext.collapse;

  var normalizedWidth = {};

  if (typeof width === 'number' || typeof width === 'string') {
    normalizedWidth.mobile = width;
    normalizedWidth.desktop = width;
  } else {
    normalizedWidth = width;
  }

  if (collapse) {
    normalizedWidth.mobile = undefined;
  }

  var resolvedColumnWidth = resolveResponsiveProp(normalizedWidth, 'column', styles);
  return /*#__PURE__*/React.createElement(Box, {
    className: [resolvedColumnWidth, _defineProperty({}, styles.collapse, collapse)] // `columnStart` is not a responsive value, which cuts down on the amount
    // of extra CSS we need to generate and include in bundles. If the need
    // arises for having this value differ between mobile and desktop in a
    // certain design, we can consider making it responsive. That would just
    // entail generating CSS like
    // ```
    // .col-start-4 { grid-column-start: 4 }
    // @ media @breakpoint-wide { .col-start-4--wide { grid-column-start: 4 } }
    // ```
    // and so on for all grid column indices.
    ,
    "data-currency": "Column",
    style: columnStart ? {
      gridColumnStart: columnStart
    } : undefined
  }, children);
};